/** Toneartene brukeren kan velge i steg 2 og på radene i kontrollen: dur, så moll. */
const DUR = ['C', 'C#', 'D', 'Eb', 'E', 'F', 'F#', 'G', 'Ab', 'A', 'Bb', 'B'];
export const TONEARTER: readonly string[] = [...DUR, ...DUR.map((t) => `${t}m`)];
